import { Grid, IconButton, Tooltip } from '@mui/material'
import { useCallback, useEffect, useState } from 'react'
import { MdAdd, MdArrowBack } from 'react-icons/md'
import Programa from '../../../components/Programa/Programa'
import { metodoPrograma } from '../../../components/api'
import PrimeTable from '../../../components/PrimeTable'
import Edicao from './Edicao'

export const STATUS_MAP = {
  0: { label: 'Recebido', color: '#13cf42', background: '#f6fbff' },
  1: { label: 'Depositado', color: '#13cf42', background: '#f6fbff' },
  2: { label: 'Compensado', color: '#13cf42', background: '#f6fbff' },
  3: { label: 'Devolvido', color: '#13cf42', background: '#f6fbff' },
  4: { label: 'Cancelado', color: '#13cf42', background: '#f6fbff' },
  5: { label: 'Repassado', color: '#13cf42', background: '#f6fbff' },
}

export function StatusChip({ status }) {
  const info = STATUS_MAP[status]

  if (!info) return status

  return (
    <span
      style={{
        display: 'inline-block',
        padding: '4px 10px',
        borderRadius: '12px',
        fontSize: '13px',
        fontWeight: 600,
        width: '100%',
        color: info.color,
        backgroundColor: info.background,
        textAlign: 'center',
      }}
    >
      {info.label}
    </span>
  )
}

const Cheque = () => {
  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [dados, setDados] = useState(null)
  const [refresh, setRefresh] = useState(0)

  const voltar = useCallback(() => {
    setTela('lista')
    setDados(undefined)
  }, [])

  const exclui = useCallback((dados) => {
    metodoPrograma('exclui', { idControleCheque: dados[0] }).then((res) => {
      if (res.status) setRefresh((prev) => prev + 1)
    })
  }, [])

  const handleClick = (linha) => {
    setDados(linha)
    setTela('opcoes')
  }

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Adicionar">
            <IconButton onClick={() => setTela('opcoes')}>
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
    }
  }, [tela, voltar])

  return (
    <Programa codigo="CtrlCheque" ferramentas={ferramentas}>
      {tela === 'lista' ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <PrimeTable
              codigo="CtrlCheque"
              action="lista"
              rows={10}
              habSearch
              head={[
                'Nr. Cheque',
                'Banco',
                'Emitente',
                'Valor',
                'Emissão',
                'Vencimento',
                'Status',
              ]}
              line={(item) => [
                item[1],
                item[2],
                item[5],
                item[7],
                item[8],
                item[9],
                item?.[11] ? <StatusChip status={item[11]} /> : '',
              ]}
              collumnsDate={[4, 5]}
              collumnsCurrency={[3]}
              parametros={{ teste: true }}
              onRowSelect={handleClick}
              onDelete={{ index: 11, action: exclui }}
              refresh={refresh}
            />
          </Grid>
        </Grid>
      ) : (
        <Edicao {...{ dados, voltar, setTela }} />
      )}
    </Programa>
  )
}

export default Cheque
